export default "__VITE_PUBLIC_ASSET__31fd593a__"